import styled from "@emotion/styled";

export const ItemsTableRoot = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  padding: 4rem;
`;
